/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Status_Installing_With_Gtb_PageInputs */



/**
* | output |
* | --- |
* | "Being installed (with BMS page)" |
*
* @param {Module_Settings_Status_Installing_With_Gtb_PageInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_status_installing_with_gtb_page = /** @type {((inputs?: Module_Settings_Status_Installing_With_Gtb_PageInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Status_Installing_With_Gtb_PageInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Being installed (with BMS page)")
	return /** @type {LocalizedString} */ ("En cours d'installation (avec page GTB)")
});